import { ISystemParameterService } from "../../service/systemparameter/SystemParameterService";

export default class RemoveSystemParametersInteractor {
  private systemParameterService: ISystemParameterService;

  constructor(systemParameterService) {
    this.systemParameterService = systemParameterService;
  }

  async execute(id: number) {
    return this.systemParameterService.deleteSystemParameter(id);
  }
}
